<div class="container">
    <div class="page-area">
        <div class="header">Advanced Tools</div>
        <div class="body-part">
            <div class="row link"><a class="link" href="/api/" target="_blank">Tamale API</a></div>
            <div class="row title-1">Learn how to leverage your data programmatically with this interactive API
                documentation.
            </div>
            <div class="line row"></div>
            <div *ngIf="isAdminUser">
                <div class="row no-link">Manage Relationship in Web</div>
                <div class="content">
                    <div class="row title-1 content-left">Grant or restrict access to the creation and management of
                        relationships through the Relationship Tree.
                    </div>
                    <div class="content-righ">
                        <button tam-button [tamType]="'primary'" [tamSize]="'normal'"
                            (click)="onBtnManageRelationship()">Manage</button>
                    </div>
                </div>
                <div class="line row"></div>
            </div>
        </div>
        <div class="footer caption-1">*Access restricted to internal networks, and users with administrative credentials
        </div>
    </div>
</div>